import styled from "styled-components";

export const TopNavBarOneContainer = styled.div`
  display: flex;
  padding: 6px 10px;
  justify-content: flex-end;
  button {
    background: none;
    border: none;
    outline: none;
  }
  .icon-btn {
    margin: 0px 2px;
  }
  .dropdown_menu_container {
    overflow: visible;
    position: relative;
  }
  .menu_box {
    display: none;
    position: absolute;
    top: 110%;
    right: -5px;
    background-color: white;
    z-index: 500;
    min-width: 220px;
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 12px;
  }
  .show_menu {
    display: flex !important;
    flex-direction: column;
    justify-content: space-around;
  }
  .menu_btn {
    display: flex;
    justify-content: flex-start;
  }
`;
